import React from 'react';
const Header = () => <header className="desktop-flex-header"/>
export default Header;